import client from './client'
import type { Venue, StoreVenuePayload, UpdateVenuePayload } from '@/types/events'

const base = (organisationId: number): string =>
  `/organizer/organisations/${organisationId}/venues`

export async function listVenues(organisationId: number): Promise<Venue[]> {
  const { data } = await client.get<{ data: Venue[] }>(base(organisationId))
  return data.data
}

export async function showVenue(organisationId: number, venueId: number): Promise<Venue> {
  const { data } = await client.get<{ data: Venue }>(`${base(organisationId)}/${venueId}`)
  return data.data
}

export async function createVenue(
  organisationId: number,
  payload: StoreVenuePayload,
): Promise<Venue> {
  const { data } = await client.post<{ data: Venue }>(base(organisationId), payload)
  return data.data
}

export async function updateVenue(
  organisationId: number,
  venueId: number,
  payload: UpdateVenuePayload,
): Promise<Venue> {
  const { data } = await client.put<{ data: Venue }>(
    `${base(organisationId)}/${venueId}`,
    payload,
  )
  return data.data
}

export async function deleteVenue(organisationId: number, venueId: number): Promise<void> {
  await client.delete(`${base(organisationId)}/${venueId}`)
}
